import { Grid } from 'antd';

import { ReactComponent as VideosIcon } from 'assets/icons/videos.svg';
import { ReactComponent as MatchesIcon } from 'assets/icons/matches.svg';
import { ReactComponent as NewsIcon } from 'assets/icons/news.svg';
// import { ReactComponent as BookmakersIcon } from 'assets/icons/bookmakers.svg';
import { ReactComponent as StatsIcon } from 'assets/icons/stats.svg';
import { useMemo } from 'react';
import { useTranslation } from '@inscore/shared';

const { useBreakpoint } = Grid;

const useMenuItems = () => {
    const screens = useBreakpoint();
    const isMobile = !screens.lg;

    const { t } = useTranslation();

    const menuItems = useMemo(
        () => [
            {
                key: 'matches',
                label: t('matches'),
                to: '/matches',
                icon: <MatchesIcon className="stroke-base" />,
                activeIcon: <MatchesIcon className="stroke-active" />,
            },
            {
                key: 'videos',
                label: t('videos'),
                to: '/videos',
                icon: <VideosIcon className="stroke-base" />,
                activeIcon: <VideosIcon className="stroke-active" />,
            },
            {
                key: 'news',
                label: t('news'),
                to: '/news',
                icon: <NewsIcon className="stroke-base" />,
                activeIcon: <NewsIcon className="stroke-active" />,
            },
            {
                key: 'stats',
                label: isMobile ? t('stats') : t('special_stats'),
                to: '/stats',
                icon: <StatsIcon className="stroke-base" />,
                activeIcon: <StatsIcon className="stroke-active" />,
            },
            // tbd: hidden for now, will be added later
            // {
            //     key: 'bookmakers',
            //     label: t('bookmakers'),
            //     to: '/bookmakers',
            //     icon: <BookmakersIcon className="stroke-base" />,
            //     activeIcon: <BookmakersIcon className="stroke-active" />,
            // },
        ],
        [isMobile, t]
    );

    return { menuItems };
};

export default useMenuItems;
